import React from "react";
import { AddStockGroupPayloadType } from "../../../../../commonTypes/clientSettingsTypes";
import { TableHeadersType } from "../../../../../constant/tableHeadersConstants/tableHeadersType";
import { AllGroupStockListType } from "../../../../../redux/clientSettings/clientSettingTypes";
import { TableHeader } from "../../../../commons";
import NestedTables from "./NestedTable";
import NormalTable from "./NormalTable";

type AppProps = {
  data: [] | AllGroupStockListType[];
  headers: TableHeadersType[];
  fetching: boolean;
  isEditStockGroupPresent?: boolean;
  handleEditStockGroupDetails: (data: AddStockGroupPayloadType) => void;
};

const StockTables = ({
  data,
  headers,
  fetching,
  isEditStockGroupPresent,
  handleEditStockGroupDetails,
}: AppProps) => {
  const renderList = () => {
    let finalList =
      data?.length > 0 &&
      data?.map((sideMenu: AllGroupStockListType) => {
        if (sideMenu?.is_tree == 0) {
          return (
            <NormalTable
              menuDetails={sideMenu}
              handleEditStockGroupDetails={handleEditStockGroupDetails}
              headers={headers}
              isEditStockGroupPresent={isEditStockGroupPresent}
            />
          );
        }
        else if (sideMenu?.is_tree == 1) {
          return (
            <>
              <NestedTables
                menuDetails={sideMenu}
                handleEditStockGroupDetails={handleEditStockGroupDetails}
                indentation={0.7}
                parent={""}
                isEditStockGroupPresent={isEditStockGroupPresent}
              />
            </>
          );
        }
      });

    return finalList;
  };

  return (
    <>
      <div className="jobsType">
        <table className="table table-bordered thead-light">
          <thead className="text-start sticky-table-header">
            <TableHeader tableHeader={headers} extraHeader />
          </thead>
          <tbody>
            {renderList()}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StockTables;
